import { Component, Inject, Injector, ViewEncapsulation } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { ViewerConfigurationService } from "../../viewer-components/services/viewer-configuration.service";
import { ArcGISFeatureLayerComponent } from "./arcgis-feature-layer.component";
import { PhoenixArcGISLayerResultsDialogComponent } from "../arcgis-layer-results-dialog/phoenix-arcgis-layer-results-dialog.component";
import { BaseViewerService } from "../../viewer-components/services/internal-services/viewer-services/base-viewer.service";
import { VIEWER_SERVICE } from "../../viewer-components/services/internal-services/viewer-services/inject-base-viewer.service";
import { GoogleAnalyticsService } from "../../shared/services/google-analytics.service";

@Component({
  selector: "phoenix-arcgis-feature-component",
  templateUrl: "./arcgis-feature-layer.component.html",
  styleUrls: ["./arcgis-feature-layer.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PhoenixArcGISFeatureLayerComponent extends ArcGISFeatureLayerComponent {
  constructor(
    http: HttpClient,
    viewerConfigurationService: ViewerConfigurationService,
    matDialog: MatDialog,
    public injector: Injector,
    @Inject(VIEWER_SERVICE) public viewerService: BaseViewerService,
  ) {
    super(http, viewerConfigurationService, matDialog);
  }

  loadLayers() {
    const dialog = this.matDialog.open(PhoenixArcGISLayerResultsDialogComponent, {
      data: {
        viewerService: this.viewerService,
        url: this.url,
        username: this.form.get("username").value,
        password: this.form.get("password").value,
        token: this.token,
        useBbox: this.useBbox,
        isAuthRequired: this.isAuthRequired,
        layers: this.layers,
        autofocus: false,
      },
      panelClass: "medium-panel-dialog",
      autoFocus: false,
      injector: this.injector,
    });
    dialog.afterClosed().subscribe(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
      document.getElementById("lblError").innerHTML = "";
    });
  }
}
